module.exports = __webpack_public_path__ + "static/media/like.6dfdcf58.png";